export class Score {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "Score";
    this.scene = "Score Update";
    this.data = [];
    this.page = 10002;
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    let kit = options.homeKit;

    let BGColour = options.game.home_team.variables?.[kit + "_clock_bg"];
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "000502"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" + BGColour;
    } catch (err) {}

    try {
      let stripeColour =
        options.game.home_team?.variables?.[kit + "_kit_stripe_viz"];
      xml.payload.field.find((item) => {
        return item.attr.name === "000512"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" +
        (stripeColour ?? BGColour);
    } catch (err) {}

    kit = options.awayKit;

    BGColour = options.game.away_team.variables?.[kit + "_clock_bg"];
    try {
      xml.payload.field.find((item) => {
        return item.attr.name === "000602"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" + BGColour;
    } catch (err) {}

    try {
      let stripeColour =
        options.away_team?.variables?.[kit + "_kit_stripe_viz"];
      xml.payload.field.find((item) => {
        return item.attr.name === "000612"; // home team back colour
      }).value =
        "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/UNIVERSAL/TEAM_COLOURS/" +
        (stripeColour ?? BGColour);
    } catch (err) {}

    xml.payload.field.find((item) => {
      return item.attr.name === "100"; // Number
    }).value = options.game?.home_team?.variables?.badge || "";
    // xml.payload.field.find((item) => {
    //   return item.attr.name === "101"; // Number
    // }).value = options.game?.home_team?.variables?.alpha_badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "120"; // Number
    }).value = options.game?.away_team?.variables?.badge || "";
    // xml.payload.field.find((item) => {
    //   return item.attr.name === "121"; // Number
    // }).value = options.game?.away_team?.variables?.alpha_badge || "";

    let home_score = 0;
    let away_score = 0;

    if (options.period >= 1) {
      home_score += parseInt(options?.game?.scores_by_quarter?.home?.first);
      away_score += parseInt(options?.game?.scores_by_quarter?.away?.first);
    }
    if (options.period >= 2) {
      home_score +=
        parseInt(options?.game?.scores_by_quarter?.home?.second) || 0;
      away_score += parseInt(
        options?.game?.scores_by_quarter?.away?.second || 0,
      );
    }
    if (options.period >= 3) {
      home_score += parseInt(
        options?.game?.scores_by_quarter?.home?.third || 0,
      );
      away_score += parseInt(
        options?.game?.scores_by_quarter?.away?.third || 0,
      );
    }
    if (options.period >= 4) {
      home_score += parseInt(
        options?.game?.scores_by_quarter?.home?.fourth || 0,
      );
      away_score += parseInt(
        options?.game?.scores_by_quarter?.away?.fourth || 0,
      );
    }
    if (options.period >= 5) {
      home_score += parseInt(options?.game?.scores_by_quarter?.home?.fith || 0);
      away_score += parseInt(options?.game?.scores_by_quarter?.away?.fith || 0);
    }

    xml.payload.field.find((item) => {
      return item.attr.name === "105"; // Number
    }).value = (home_score || 0 || "0") + "-" + (away_score || 0 || "0");

    xml.payload.field.find((item) => {
      return item.attr.name === "200"; // Number
    }).value = options.subtitle;

    xml.payload.field.find((item) => {
      return item.attr.name === "103"; // Number
    }).value = options?.game?.home_team?.short_name;

    xml.payload.field.find((item) => {
      return item.attr.name === "123"; // Number
    }).value = options?.game?.away_team?.short_name;

    await this.updateVizPage({ page: this.page, data: xml });
    this.sendPreview("page:read " + this.page);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    clearTimeout(this.to);
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
